import { render, staticRenderFns } from "./QuotationSettingsList.vue?vue&type=template&id=d1383b34"
import script from "./QuotationSettingsList.vue?vue&type=script&lang=js"
export * from "./QuotationSettingsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports